import ViewLoader from './view-loader';

class NewsList {
    constructor($container) {
        this.$container = $container;
        this.$list = this.$container.querySelector('.js-news-list-results');
        this.$moreBtn = this.$container.querySelector('.js-news-list-more');
        this.paginationUrl = this.$container.dataset.paginationUrl;
        this.url = this.$container.dataset.url;

        this.itemTemplate = this.$container.querySelector('.js-news-item-template').innerHTML;
        this.emptyTemplate = this.$container.querySelector('.js-news-empty-template').innerHTML;
        this.errorTemplate = this.$container.querySelector('.js-news-error-template').innerHTML;

        this.init();
    }

    async init() {
        let perPage = parseInt(this.$container.dataset.perPage, 10) || 6,
            offset = parseInt(this.$container.dataset.offset, 10);

        this.viewLoader = new ViewLoader(this.$list, this.$moreBtn, perPage, offset,
            {
                itemTemplate: this.itemTemplate,
                emptyTemplate: this.emptyTemplate,
                errorTemplate: this.errorTemplate
            },
            {
                getUrl: () => this.url,
                getPaginationUrl: () => this.paginationUrl
            }
        );
    }
}

export default NewsList;



// WEBPACK FOOTER //
// ./sources/js/components/news-list.js